import isEmpty from 'lodash/isEmpty';
import { TBlockType } from 't2-keystone/src/services/body/types';
import { ARTICLE_BLOCK_CLASSNAME } from '../../../ArticleBodyRenderer/constants';
import { closestNode } from '../../../../services/dom/closestNode';
import { getHighlightBlockFromHtml } from './getHighlightBlockFromHtml';
import { wrapSelectionHtmlWithRequiredGrandparents } from './wrapSelectionHtmlWithRequiredGrandparents';
import { TArticleHighlight } from '../../types';
import { TArticleBody } from '../../../ArticleBodyRenderer/types';
import { getBodyBlockWithId } from '../../../ArticleBodyRenderer/services/getBodyBlockWithId';

export const getHighlightBlocksDataFromRange = (range: Range, body: TArticleBody): TArticleHighlight['blocks'] => {
  const articleBlocksFromRange = Array.from(
    range.cloneContents().querySelectorAll(`.${ARTICLE_BLOCK_CLASSNAME}`).values(),
  );
  if (!isEmpty(articleBlocksFromRange)) {
    return articleBlocksFromRange.map((element) => getHighlightBlockFromHtml(body, element.id, element.innerHTML));
  }

  const rangeParentArticleBlock = closestNode(range.startContainer, `.${ARTICLE_BLOCK_CLASSNAME}`);
  const bodyBlockData = getBodyBlockWithId(body, rangeParentArticleBlock.id);
  const rangeHtmlWithRequiredParents = wrapSelectionHtmlWithRequiredGrandparents(
    range,
    bodyBlockData?.type as TBlockType,
  );
  return [getHighlightBlockFromHtml(body, rangeParentArticleBlock.id, rangeHtmlWithRequiredParents)];
};

export const getHighlightDataFromRange = (range: Range, body: TArticleBody): TArticleHighlight => {
  const blocks = getHighlightBlocksDataFromRange(range, body);
  return {
    version: body?.version as string,
    blocks,
    time: Math.floor(new Date().getTime() / 1000),
  };
};
